import { MemberSpacesTab } from "@/components/members/detail/member-spaces-tab.tsx";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
	"/_authenticated/settings/org/members/$userId/spaces",
)({
	component: () => <MemberSpacesTab kind="spaces" />,
});
